// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"32b6d3f8","41":"3a3212a2","243":"30716591","275":"0c9a1278","657":"c455215f"}[chunkId] + ".chunk.js";
};